// 발행/가이드 등 웹 렌더링에서 인라인 코드(<code class="inline-code">)를 클릭하면
// 해당 텍스트가 클립보드로 복사된다. (에디터/이메일에는 적용하지 않고 웹 뷰 전용)
//
// 사용: 콘텐츠 컨테이너에 data-controller="components--inline-code-copy" 를 붙인다.
import { Controller } from "@hotwired/stimulus";
import { createFlash } from "@/utils/flash";

export default class extends Controller {
  connect() {
    this.onClick = this.onClick.bind(this);
    this.element.addEventListener("click", this.onClick);
    this.decorate();
  }

  disconnect() {
    this.element.removeEventListener("click", this.onClick);
  }

  // 클릭 가능함을 알리는 커서/툴팁 부여
  decorate() {
    this.element.querySelectorAll("code.inline-code").forEach((el) => {
      el.style.cursor = "pointer";
      if (!el.title) el.title = "클릭하면 복사됩니다";
    });
  }

  onClick(event) {
    const code = event.target.closest("code.inline-code");
    if (!code || !this.element.contains(code)) return;

    const text = code.textContent || "";
    if (!text) return;

    this.writeToClipboard(text)
      .then(() => {
        createFlash({ key: "check", ttl: 2, message: "복사되었습니다.", stack: false });
      })
      .catch(() => {
        createFlash({ key: "error", ttl: 2, message: "복사에 실패했습니다.", stack: false });
      });
  }

  writeToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise((resolve, reject) => {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand("copy") ? resolve() : reject();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }
}
